import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { useActions } from 'app/components/Utility/hooks/useAction.hooks';
// ANTD
import { Skeleton, Typography } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';

import { isIE } from 'react-device-detect';

const { Paragraph } = Typography;

const iconStyle = { fontSize: 16, color: '#aa2493' };

let delay = null;

const PlaceTitle = () => {
  const { PlaceSetTitle } = useActions();
  const title = useSelector((store) => store.placesData.data.title);
  const fetched = useSelector((store) => store.placesData.fetched);
  const fetching = useSelector((store) => store.placesData.fetching);
  const isEditMode = useSelector((store) => store.placesData.isEditMode);
  const publicTypeRequiredFiled = useSelector(
    (store) => store.placesData.publicTypeRequiredFiled
  );

  const refTitle = useRef(null);

  const [showExpandTitle, setShowExpandTitle] = useState(false);
  const [expand, setExpand] = useState(false);
  const [input, setInput] = useState(title);

  useEffect(() => {
    if (fetched && refTitle.current) {
      const height = refTitle.current.offsetHeight;
      const defaultHeightOfTitle = 60;
      if (height > defaultHeightOfTitle) setShowExpandTitle(true);
    }
  }, [fetched, isEditMode]);

  useEffect(() => {
    setInput(title);
  }, [title]);

  const onChangeTitle = (str) => {
    // const tourData = { ...activeMultiPart };
    // tourData.title = str;
    PlaceSetTitle(str);
  };

  const onChange = (value) => {
    setInput(value);
    if (delay) {
      clearTimeout(delay);
    }
    delay = setTimeout(() => {
      onChangeTitle(value);
    }, 800);
  };

  const getRowNumber = () => {
    if (isEditMode || isIE) {
      return 1;
    }
    if (expand) {
      return 1000;
    }
    return 2;
  };

  return fetching === true ? (
    <Skeleton paragraph={false} title={{ width: 200 }} active />
  ) : (
    <>
      {isEditMode ? (
        <TextArea
          rows={1}
          value={input}
          onChange={(e) => onChange(e.target.value)}
        />
      ) : (
        <Paragraph
          editable={false}
          ellipsis={{ rows: getRowNumber() }}
          style={
            !publicTypeRequiredFiled.title
              ? { border: '1px solid red', borderRadius: '4px' }
              : { border: '1px solid transparent' }
          }
        >
          <span ref={refTitle}>{input}</span>
        </Paragraph>
      )}
      {showExpandTitle && !isEditMode && !isIE ? (
        <span onClick={() => setExpand(!expand)} aria-hidden="true">
          {expand ? (
            <CaretUpOutlined style={iconStyle} />
          ) : (
            <CaretDownOutlined style={iconStyle} />
          )}
        </span>
      ) : null}
    </>
  );
};
export default PlaceTitle;
